import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit, fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const EmployerForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [industryTypes, setIndustryTypes] = useState([]);

  useEffect(() => {
    async function fetchIndustryTypes() {
      try {
        const response = await fetchJsonDynamic(
          "allIndustryTypes",
          null,
          null,
          setup_url
        );
        setIndustryTypes(JSON.parse(response.results));
      } catch (error) {
        console.error("Error fetching industry types:", error);
      }
    }
    fetchIndustryTypes();
  }, []);

  const initialValues = {
    employer: props.data ? props.data.Employer : "",
    location: props.data ? props.data.Location : "",
    postalCode: props.data ? props.data.PostalCode : "",
    postalAddress: props.data ? props.data.PostalAddress : "",
    industryTypeId: props.data ? props.data.IndustryTypeId : "",
  };

  const validationSchema = yup.object().shape({
    employer: yup.string().required("Employer Name required"),
    location: yup.string().required("Location is required"),
    postalAddress: yup.string().required("Postal Address is required"),
    postalCode: yup.string().required("Postal Code is required"),
    industryTypeId: yup.string().required("Industry Type is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const variables = props.isEditing
      ? { id: props.data.Id, ...values }
      : values;

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateEmployer" : "createEmployer",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Employer",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Employer" : "Create Employer"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Employer"
            : "Create a New Employer"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Employer Name*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.employer}
                name="employer"
                error={touched.employer && !!errors.employer}
                helperText={touched.employer && errors.employer}
                sx={{ gridColumn: "span 2" }}
              />
               <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Location*"
                name="location"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.location}
                error={touched.location && !!errors.location}
                helperText={touched.location && errors.location}
              />
               <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Postal Code*"
                  name="postalCode"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.postalCode}
                  error={touched.postalCode && !!errors.postalCode}
                  helperText={touched.postalCode && errors.postalCode}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Postal Address*"
                  name="postalAddress"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.postalAddress}
                  error={touched.postalAddress && !!errors.postalAddress}
                  helperText={touched.postalAddress && errors.postalAddress}
                />

            <FormControl fullWidth variant="filled" error={touched.industryTypeId && !!errors.industryTypeId}>
              <InputLabel id="industryTypeId-label">Industry Type*</InputLabel>
              <Select
                labelId="industryTypeId-label"
                id="industryTypeId"
                name="industryTypeId"
                value={values.industryTypeId}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <MenuItem value="">
                  <em>Select Industry Type</em>
                </MenuItem>
                {industryTypes.map((item) => (
                  <MenuItem key={item.Id} value={item.Id}>
                    {item.Name}
                  </MenuItem>
                ))}
              </Select>
              {touched.industryTypeId && errors.industryTypeId && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                  {errors.industryTypeId}
                </div>
              )}
            </FormControl>

            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default EmployerForm;
